import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { BackTop } from 'antd';

function ScrollToTop({ children }) {
  const location = useLocation();
  const target = useMemo(() => document.getElementById('content'), [location.pathname]);
  
  useEffect(() => {
    const content = document.getElementById('content');
    if (children && content) {
      content.scrollTop = 0
    }
  }, [location]);


  return <>{children}
	<BackTop visibilityHeight={500} {...(target ? { target: () => target } : {})}/>
  </>;
}
export default ScrollToTop;